const initialState = {};
import * as Constants from '../constants';


export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.GET_ACTIVE_REFILLS_SUCCESS:
      return Object.assign(action.data);
    case Constants.GET_ACTIVE_REFILLS_FAILURE:
      return Object.assign(action.data);
    default:
      return {
        ...state
      }
  }
}
